import React, { useMemo } from 'react';
import ChatBubble from './ChatBubble';
import { ThreadMessage, normalizeThreadMessage } from '../../../../types/threadMessage';

export interface ChatThreadProps {
  messages: any[];
  customerName?: string;
  className?: string;
  showMeta?: boolean;
  renderAction?: (message: ThreadMessage, index: number) => React.ReactNode;
}

const ChatThread: React.FC<ChatThreadProps> = ({ messages, customerName = 'Customer', className, showMeta = true, renderAction }) => {
  const normalized: ThreadMessage[] = useMemo(() => {
    return (messages || []).map((m) => normalizeThreadMessage(m, customerName));
  }, [messages, customerName]);

  if (!normalized || normalized.length === 0) return null;

  return (
    <div className={className}>
      {normalized.map((msg, idx) => (
        <ChatBubble
          key={idx}
          message={msg}
          align={msg.author_type === 'agent' || msg.author_type === 'system' ? 'right' : 'left'}
          showMeta={showMeta}
          fallbackCustomerName={customerName}
          renderAction={renderAction ? () => renderAction(msg, idx) : undefined}
        />
      ))}
    </div>
  );
};

export default ChatThread;

